module.exports = __webpack_public_path__ + "static/tyrinetojas-011c4460ba15e1abbe82962f25e773e8.svg";